/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Stage_LostInputs */

const cs_pipelines_stage_lost = /** @type {(inputs: Pipelines_Stage_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fáze prohry`)
};

const en_pipelines_stage_lost = /** @type {(inputs: Pipelines_Stage_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lost stage`)
};

/**
* | output |
* | --- |
* | "Lost stage" |
*
* @param {Pipelines_Stage_LostInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_stage_lost = /** @type {((inputs?: Pipelines_Stage_LostInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Stage_LostInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_stage_lost(inputs)
	return cs_pipelines_stage_lost(inputs)
});